/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/common-utils';
import { Grid, Icon, Text } from '@zapier/design-system';

import Link from 'app/common/components/Link';
import { HELP_CENTER } from 'app/developer-v3/teams/team-technical-support-operations/get-help';

export const ContactUs = () => {
  return (
    <div>
      <Grid alignItems="center" columns="20px 1fr" gap="10px">
        <Icon name="navHelpFill" size={20} />
        <Text fontWeight={600} type="Body1">
          Need help with your Zapier account, Zaps, or have a general question
          about Zapier?
        </Text>
      </Grid>
      <Text type="Body1">
        Visit the main Zapier{' '}
        <Link href={HELP_CENTER} target="_blank">
          Help Center
        </Link>{' '}
        for help with building and troubleshooting your Zaps.
      </Text>
    </div>
  );
};
